"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiOpciNombreSouscriptions = void 0;
exports.ESubScpiOpciNombreSouscriptions = {
    moins_de_3: "moins_de_3",
    plus_de_3: "plus_de_3",
};
